module.exports = "<div class=\"card-container\" (click)=\"onClickTriggered()\">\r\n  <div class=\"card-title-container\" [style.background-color]=\"backgroundColor\">\r\n    <div>\r\n      <p class=\"card-title\">{{ titleUp }}</p>\r\n      <p class=\"card-title\">{{ titleDown }}</p>\r\n    </div>\r\n    <img class=\"background-image\" [src]=\"imageUrl\">\r\n  </div>\r\n  <p class=\"card-content\">{{ content }}</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/myJssi-card/my-jssi-card.component.html
// module id = ./src/app/shared-components/myJssi-card/my-jssi-card.component.html
// module chunks = main